<template functional>
  <div :class="props.size ? `col col-sm-${props.size}` : 'col col-sm'">
    <div class="content-wrapper">
      <span v-if="props.label" class="d-block d-sm-none font-weight-bold">{{ props.label }}:</span>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VGridColumn',
  props: {
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: '__',
    },
    size: {
      type: Number,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
.content-wrapper {
  display: flex;

  span {
    flex: 1;
  }
}
</style>
